import i18n from '../../utils/i18n'

export const PackagingTypeBodyTemplate = (packagingType: any) => {
  if (!packagingType) return null

  return (
    <>
      {i18n.t(
        `masterDataManagement.packagingData.table.columns.packagingMaterial.options.${packagingType}`,
      )}
    </>
  )
}
